import { render, staticRenderFns } from "./PingPong.vue?vue&type=template&id=936e2a5e&scoped=true&"
import script from "./PingPong.vue?vue&type=script&lang=js&"
export * from "./PingPong.vue?vue&type=script&lang=js&"
import style0 from "./PingPong.vue?vue&type=style&index=0&id=936e2a5e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "936e2a5e",
  null
  
)

export default component.exports